import { env } from 'configs/EnvironmentConfig'
import fetch from 'auth/FetchInterceptor'
import { z } from 'zod'
import { Validate } from './SchemaValidation'

const dnsSchema = z.object({
  name: z.string(),
  domain_id: z.number().int(),
  type: z.enum(['A', 'AAAA', 'CNAME', 'MX', 'TXT', 'SRV', 'NS']),
  ttl: z.number(),
})

const dnsUpdateSchema = z.object({
  name: z.string(),
  type: z.enum(['A', 'AAAA', 'CNAME', 'MX', 'TXT', 'SRV', 'NS']),
  ttl: z.number(),
})

const typeBodyValidate = {
  A: z.object({
    ip: z.string(),
  }),
  AAAA: z.object({
    ip: z.string(),
  }),
  CNAME: z.object({
    target: z.string(),
  }),
  MX: z.object({
    preference: z.number(),
    mx: z.string(),
  }),
  TXT: z.object({
    txt: z.string(),
  }),
  SRV: z.object({
    priority: z.number(),
    weight: z.number(),
    port: z.number(),
    target: z.string(),
  }),
  NS: z.object({
    ns: z.string(),
  }),
}

const numberId = z.number()

const DnsService = {}

DnsService.getDnsList = ({ domainId, limit, page }) =>
  fetch({
    url: `${env.DNS_ENDPOINT_URL}/api/dns-record?domain_id=${Validate(
      numberId,
      domainId
    )}&page=${page}&limit=${limit}`,
    method: 'GET',
  })

DnsService.deleteDns = id =>
  fetch({
    url: `${env.DNS_ENDPOINT_URL}/api/dns-record/${Validate(numberId, id)}`,
    method: 'DELETE',
  })

DnsService.createDns = ({ domainId, name, type, ttl, ...dnsTypeBody }) => {
  const dnsBody = Validate(dnsSchema, {
    name,
    type,
    ttl,
    domain_id: domainId,
  })
  Validate(typeBodyValidate[type], dnsTypeBody[type.toLowerCase()])

  return fetch({
    url: `${env.DNS_ENDPOINT_URL}/api/dns-record?domain_id=${Validate(
      numberId,
      domainId
    )}`,
    method: 'POST',
    data: {
      ...dnsBody,
      ...dnsTypeBody,
    },
  })
}

DnsService.updateDns = ({ id, name, type, ttl, ...dnsTypeBody }) => {
  const dnsBody = Validate(dnsUpdateSchema, {
    name,
    type,
    ttl,
  })
  Validate(typeBodyValidate[type], dnsTypeBody[type.toLowerCase()])

  return fetch({
    url: `${env.DNS_ENDPOINT_URL}/api/dns-record/${Validate(numberId, id)}`,
    method: 'PUT',
    data: {
      ...dnsBody,
      ...dnsTypeBody,
    },
  })
}

export default DnsService
